export enum BulkActionTypeEnum {
    CREATE = 'Create'
}